<template>
  <div class="gift-box-index">
    <ModalContactForm v-if="showContactModal" :selected-type="selectedType" @close="showContactModal = false"/>
    <ModalContactFormSuccess v-if="success" @close="success = false" />
    <div class="top-banner" :class="selectedType === 'entreprise' ? 'top-banner-entreprise' : 'top-banner-cse-collective'" data-aos="fade-up" data-aos-duration="900">
      <div class="image-gradient-bottom"></div>
      <div class="top-banner-content">
        <p :class="isPhone ? 'merriweather-reg-32' : 'merriweather-reg-40'">Le coffret cadeau Hortense</p>
        <p class="merriweather-reg-18">Plus qu’un cadeau, une expérience unique, éthique et durable</p>
      </div>
    </div>
    <div class="selection-btns-container w-100 mt-4">
      <div class="selection-button" :class="selectedType === 'entreprise' ? 'selected' : ''" @click="goToLink('/coffrets-cadeaux-entreprise')">
        ENTREPRISES
      </div>
      <div class="selection-button" :class="selectedType === 'cse-collective' ? 'selected' : ''" @click="goToLink('/coffrets-cadeaux-cse')">
        CSE - COLLECTIVITÉS
      </div>
    </div>
    <div class="row offer-container mt-4" v-if="selectedType === 'entreprise'">
      <div class="d-flex flex-column align-items-center justify-content-center w-100">
        <p :class="isPhone ? 'merriweather-reg-20' : 'merriweather-reg-26'" class=" mb-0 text-center">Offrez un séjour authentique et éco-responsable</p>
        <p :class="isPhone ? 'merriweather-reg-28' : 'merriweather-reg-40'" class="mb-0 text-center">à vos collaborateurs et partenaires</p>
      </div>
      <div class="raleway-reg-p15 text-center">
        Avec Hortense, offrez bien plus qu’un séjour : une <span class="raleway-semi-p15">expérience éco-responsable</span>, ancrée dans les territoires, qui valorise un <span class="raleway-semi-p15">tourisme local et durable…</span> Chaque <span class="raleway-semi-p15">coffret Hortense</span> est unique : bien plus qu’un simple cadeau, c’est une <span class="raleway-semi-p15">expérience sur-mesure et privilégiée</span>. <span v-if="!isPhone || (isPhone && showMoreOfferContent)">Alliant hébergements de charme engagés, conciergerie personnalisée, <span class="raleway-semi-p15">privilèges exclusifs</span> et un guide de voyage local. Grâce à nos coffrets, vos collaborateurs et partenaires se sentiront véritablement valorisés et choyés, grâce à une <span class="raleway-semi-p15">expérience hors du commun</span> accompagnée d’un <span class="raleway-semi-p15">vrai service personnalisé</span></span>.
      </div>
      <p v-if="isPhone && !showMoreOfferContent" class="text-center w-100 link-text mt-4 mb-0" @click="showMoreOfferContent = true">Voir plus</p>
      <p v-else-if="isPhone && showMoreOfferContent" class="text-center w-100 link-text mt-4 mb-0" @click="showMoreOfferContent = false">Voir moins</p>
      <div class="d-flex w-100 justify-content-center align-items-center" :class="isPhone ? 'px-5 mt-4' : ''">
        <div class="hortense-btn-primary" @click="scrollToElement('contactForm')">NOUS CONTACTER</div>
      </div>
    </div>
    <div class="row offer-container mt-4" v-if="selectedType === 'cse-collective'">
      <div class="d-flex flex-column align-items-center justify-content-center w-100">
        <p :class="isPhone ? 'merriweather-reg-20' : 'merriweather-reg-26'" class=" mb-0 text-center">Offrez à vos collaborateurs le choix</p>
        <p :class="isPhone ? 'merriweather-reg-28' : 'merriweather-reg-40'" class="mb-0 text-center">d’expériences éco-responsables</p>
      </div>
      <div class="raleway-reg-p15 text-center">
        Chez Hortense, nous sommes convaincus que le <span class="raleway-semi-p15">bien-être des salariés passe par le voyage</span>, par ces moments de découverte, de détente et de partage qui créent de vrais souvenirs.<br> <span v-if="!isPhone || (isPhone && showMoreOfferContent)">Pensée pour les CSE, Collectivités et associations, notre offre valorise vos équipes avec un cadeau porteur de sens, entre détente, découverte et partage.</span>
      </div>
      <span v-if="!isPhone || (isPhone && showMoreOfferContent)" class="raleway-semi-p15 pt-2 text-center w-100">Offrez une parenthèse précieuse. Offrez Hortense.</span>
      <p v-if="isPhone && !showMoreOfferContent" class="text-center w-100 link-text mt-4 mb-0" @click="showMoreOfferContent = true">Voir plus</p>
      <p v-else-if="isPhone && showMoreOfferContent" class="text-center w-100 link-text mt-4 mb-0" @click="showMoreOfferContent = false">Voir moins</p>
      <div class="d-flex w-100 justify-content-center align-items-center" :class="isPhone ? 'px-5 mt-4' : ''">
        <div class="hortense-btn-primary" @click="scrollToElement('contactForm')">NOUS CONTACTER</div>
      </div>
    </div>
    <div class="mb-5 coffert-hortense-container mt-5" :class="isPhone ? '' : 'mt-2'">
      <div class="d-flex flex-column align-items-center justify-content-center">
        <p :class="isPhone ? 'merriweather-reg-20' : 'merriweather-reg-26'" class=" mb-0 text-center">Le Coffret cadeau Hortense : </p>
        <p :class="isPhone ? 'merriweather-reg-28' : 'merriweather-reg-40'" class="mb-0 text-center">bien plus qu’une simple nuit</p>
        <p :class="isPhone ? 'merriweather-light-18' : 'merriweather-light-24'" class="text-center mb-2">Un séjour personnalisé, enrichi de <span :class="isPhone ? 'merriweather-light-italic-18' : 'merriweather-light-italic-24'">découvertes</span> et de <span :class="isPhone ? 'merriweather-light-italic-18' : 'merriweather-light-italic-24'">privilèges</span></p>
      </div>
      <CoffretHortense />
      <div class="raleway-reg-p15 text-center mt-4" :class="isPhone ? '' : 'px-5'">Vous pouvez acheter nos coffrets cadeaux directement en ligne si vous ne souhaitez pas de personnalisation et pour toute commande inférieure à 100 exemplaires. Au-delà ou en cas de personnalisation, <a class="link-hortense" @click="scrollToElement('contactForm')">n’hésitez pas à nous contacter directement.</a></div>
      <div class="d-flex w-100 justify-content-center align-items-center mt-5" :class="isPhone ? 'px-4' : ''">
        <div class="hortense-btn-primary" @click="goToLink('/coffrets-cadeaux/paiement')">ACHETEZ NOS COFFRETS EN LIGNE</div>
      </div>
    </div>
    <div v-if="false" class="mb-5 award-container mt-5" :class="isPhone ? '' : 'mt-2'">
      <div class="d-flex flex-column align-items-center justify-content-center">
        <p :class="isPhone ? 'merriweather-reg-20' : 'merriweather-reg-26'" class=" mb-0 text-center">Un nouvel art</p>
        <p :class="isPhone ? 'merriweather-reg-28' : 'merriweather-reg-40'" class="mb-0 text-center">de récompenser et de valoriser</p>
      </div>
      <div class="row-grid mt-4" data-aos="fade-up" data-aos-duration="900">
        <div class="grid-col">
          <div class="d-flex flex-column align-items-center justify-content-center">
            <img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Coffrets+cadeaux+-+BtoB/S%C3%A9jours-authentiques-%C3%A9coresponsables.webp" v-set-alt>
            <p class="raleway-semi-p16 w-100 mt-2 text-uppercase">Des séjours authentiques éco-responsables</p>
            <p class="raleway-reg-p15 w-100">Offrez à vos salariés des escapades en France, à tarif préférentiel, dans des lieux de charme engagés pour un tourisme plus responsable.</p>
          </div>
        </div>
        <div class="grid-col">
          <div class="d-flex flex-column align-items-center justify-content-center">
            <img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Coffrets+cadeaux+-+BtoB/coffrets-cadeaux-uniques.webp" v-set-alt>
            <p class="raleway-semi-p16 w-100 mt-2 text-uppercase">Des coffrets cadeaux uniques</p>
            <p class="raleway-reg-p15 w-100">Des coffrets éligibles aux événements URSSAF (Noël, rentrée scolaire, départ à la retraite...) pour marquer chaque occasion d'une attention soignée.</p>
          </div>
        </div>
        <div class="grid-col">
          <div class="d-flex flex-column align-items-center justify-content-center">
            <img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Coffrets+cadeaux+-+BtoB/decouverte-culturelle-et-locale.webp" v-set-alt>
            <p class="raleway-semi-p16 w-100 mt-2">DÉCOUVERTE CULTURELLE ET LOCALE</p>
            <p class="raleway-reg-p15 w-100">Encouragez la découverte culturelle et locale grâce à notre guide, conçu pour inspirer des escapades authentiques et enrichissantes.</p>
          </div>
        </div>
        <div class="grid-col">
          <div class="d-flex flex-column align-items-center justify-content-center">
            <img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Coffrets+cadeaux+-+BtoB/Soutenir-les-territoires.webp" v-set-alt>
            <p class="raleway-semi-p16 w-100 mt-2">UN CADEAU QUI SE FEUILLETTE ET SE VIT</p>
            <p class="raleway-reg-p15 w-100">Un coffret élégant qui réunit une expérience de voyage à vivre et un guide inspirant pour explorer, rêver et choisir sa prochaine escapade.</p>
          </div>
        </div>
      </div>
    </div>
    <div class="mb-5 entreprise-experience-container mt-5" :class="isPhone ? '' : 'mt-2'">
      <div class="d-flex flex-column align-items-center justify-content-center">
        <p :class="isPhone ? 'merriweather-reg-20' : 'merriweather-reg-26'" class=" mb-0">Un cadeau éthique</p>
        <p :class="isPhone ? 'merriweather-reg-28' : 'merriweather-reg-40'" class="mb-0">et porteur de sens</p>
        <p :class="isPhone ? 'merriweather-light-18' : 'merriweather-light-24'" class="text-center mb-2">Le 1er coffret cadeau pour une <span :class="isPhone ? 'merriweather-light-italic-18' : 'merriweather-light-italic-24'">évasion éco-chic</span> : <span :class="isPhone ? 'merriweather-light-italic-18' : 'merriweather-light-italic-24'">un guide</span> pour s’inspirer, <span :class="isPhone ? 'merriweather-light-italic-18' : 'merriweather-light-italic-24'">une carte cadeau</span> pour s’évader</p>
      </div>
      <ExceptionalEntrepriseExperience />
    </div>
    <div class="choose-gift-box-container">
      <div class="d-flex flex-column align-items-center justify-content-center">
        <p :class="isPhone ? 'merriweather-reg-20' : 'merriweather-reg-26'" class=" mb-0">Pourquoi choisir</p>
        <p :class="isPhone ? 'merriweather-reg-28' : 'merriweather-reg-40'" class="mb-0">{{ selectedType === 'entreprise' ? 'nos coffrets cadeaux ?' : 'Hortense ?' }}</p>
      </div>
      <div class="row mt-4" data-aos="fade-up" data-aos-duration="900">
        <div class="col-12 col-md-5">
          <video
            playsinline
            autoplay
            loop
            muted
            class="video-container"
          >
            <source src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Coffrets+cadeaux+-+BtoB/pourquoi-choisir-nos-coffrets-cadeaux.mp4">
          </video>
        </div>
        <div v-if="selectedType === 'entreprise'" class="col-12 col-md-7 pr-5" :class="isPhone ? 'px-5' : ''"  data-aos="fade-left" data-aos-duration="900">
          <div class="d-flex flex-column align-items-start h-100">
            <div class="d-flex align-items-start" :class="isPhone ? 'pt-5' : ''">
              <span class="bullet mt-1 flex-shrink-0 d-flex"></span>
              <span class="raleway-reg-p15 ml-2">Accès à une <span class="raleway-bold-p15">sélection d’hébergements de charme engagés</span> en faveur du tourisme durable.</span>
            </div>
            <div class="d-flex align-items-start pt-4">
              <span class="bullet mt-1 flex-shrink-0 d-flex"></span>
              <span class="raleway-reg-p15 ml-2">Une <span class="raleway-bold-p15">expérience de voyage enrichie</span> avec privilèges, et un guide de voyage pour explorer la France tout en éveillant les consciences aux enjeux du tourisme durable.</span>
            </div>
            <div class="d-flex align-items-start pt-4">
              <span class="bullet mt-1 flex-shrink-0 d-flex"></span>
              <span class="raleway-reg-p15 ml-2">Un <span class="raleway-bold-p15">coffret cadeau éthique</span> et utile, valable 2 ans, sans packaging jetable : tout est pensé pour durer.</span>
            </div>
            <div class="d-flex align-items-start pt-4">
              <span class="bullet mt-1 flex-shrink-0 d-flex"></span>
              <span class="raleway-reg-p15 ml-2">Une <span class="raleway-bold-p15">offre adaptable</span> en fonction de vos objectifs RH, commerciaux ou marketing, avec un montant de carte cadeau modulable selon votre budget.</span>
            </div>
            <div class="d-flex align-items-start pt-4">
              <span class="bullet mt-1 flex-shrink-0 d-flex"></span>
              <span class="raleway-reg-p15 ml-2">Un <span class="raleway-bold-p15">coffret personnalisable</span> aux couleurs et à la charte de votre entreprise.</span>
            </div>
            <div class="d-flex align-items-start pt-4">
              <span class="bullet mt-1 flex-shrink-0 d-flex"></span>
              <span class="raleway-reg-p15 ml-2"> Un <span class="raleway-bold-p15">accompagnement sur mesure</span> pour vos projets BtoB, avec réactivité et simplicité.</span>
            </div>
            <div class="d-flex align-items-start pt-4">
              <span class="bullet mt-1 flex-shrink-0 d-flex"></span>
              <span class="raleway-reg-p15 ml-2"> Votre <span class="raleway-bold-p15">engagement RSE</span> renforcé avec des cadeaux responsables.</span>
            </div>
          </div>
        </div>
        <div v-if="selectedType === 'cse-collective'" class="col-12 col-md-7 pr-5" :class="isPhone ? 'px-5' : ''">
          <div class="d-flex flex-column align-items-start h-100">
            <div class="d-flex align-items-start" :class="isPhone ? 'pt-5' : ''">
              <span class="bullet mt-1 flex-shrink-0 d-flex"></span>
              <span class="raleway-reg-p15 ml-2">Des <span class="raleway-bold-p15">séjours dans des hébergements de charme</span> : hôtels confidentiels, maisons d’hôtes inspirantes, villas avec vue…. tous engagés dans une démarche écoresponsable.</span>
            </div>
            <div class="d-flex align-items-start pt-4">
              <span class="bullet mt-1 flex-shrink-0 d-flex"></span>
              <span class="raleway-reg-p15 ml-2">Une <span class="raleway-bold-p15">offre personnalisée selon vos besoins</span> : commandes groupées, cartes cadeaux physiques ou digitales, dotations pour challenges internes, etc.</span>
            </div>
            <div class="d-flex align-items-start pt-4">
              <span class="bullet mt-1 flex-shrink-0 d-flex"></span>
              <span class="raleway-reg-p15 ml-2"> Un <span class="raleway-bold-p15">accompagnement dédié</span> pour créer une offre à votre image et valoriser vos équipes durablement.</span>
            </div>
            <div v-if="!isPhone || (isPhone && showAllBullets)" class="d-flex align-items-start pt-4">
              <span class="bullet mt-1 flex-shrink-0 d-flex"></span>
              <span class="raleway-reg-p15 ml-2">Un <span class="raleway-bold-p15">guide de voyage pour voyager autrement</span>, sensibilisant à un tourisme plus responsable et plus humain dans chaque coffret.</span>
            </div>
            <div v-if="!isPhone || (isPhone && showAllBullets)" class="d-flex align-items-start pt-4">
              <span class="bullet mt-1 flex-shrink-0 d-flex"></span>
              <span class="raleway-reg-p15 ml-2">Un <span class="raleway-bold-p15">coffret cadeau éthique et utile</span>, sans packaging jetable : tout est pensé pour durer.</span>
            </div>
            <div v-if="!isPhone || (isPhone && showAllBullets)" class="d-flex align-items-start pt-4">
              <span class="bullet mt-1 flex-shrink-0 d-flex"></span>
              <span class="raleway-reg-p15 ml-2">Une <span class="raleway-bold-p15">solution clés en main</span> : sélection, réservation et service client gérés par Hortense, pour que votre CSE puisse récompenser sans complexité ni surcharge administrative.</span>
            </div>
            <p v-if="isPhone && !showAllBullets" class="text-center w-100 link-text mt-4" @click="showAllBullets = true">Voir plus</p>
            <p v-else-if="isPhone && showAllBullets" class="text-center w-100 link-text mt-4" @click="showAllBullets = false">Voir moins</p>
            <p v-if="isPhone" class="border-bottom-gray mt-4 w-100"></p>
          </div>
        </div>
      </div>
    </div>
    <div v-if="selectedType === 'entreprise'" class="occasions_container mt-5"  data-aos="fade-up" data-aos-duration="900">
      <div class="d-flex flex-column align-items-center h-100">
        <p :class="isPhone ? 'merriweather-reg-20' : 'merriweather-reg-26'" class=" mb-0">Pour quelles occasions</p>
        <p :class="isPhone ? 'merriweather-reg-28 text-center' : 'merriweather-reg-40'" class="mb-0">offrir nos coffrets cadeaux entreprise ?</p>
        <p :class="isPhone ? 'merriweather-light-18' : 'merriweather-light-24'" class="text-center mb-2">Un <span :class="isPhone ? 'merriweather-light-italic-18' : 'merriweather-light-italic-24'">levier RSE</span> au service de vos objectifs professionnels</p>
      </div>
      <div class="row mt-5 tester">
        <div class="col-12 col-md-4 occasion-selections" :class="[occasionSelection === 'option1' ? 'selected' : '', isPhone ? 'mt-3' : 'ml-3']" @click="occasionSelection = 'option1'">
          <div class="w-100 d-flex flex-column align-items-center justify-content-center h-100">
            <span class="raleway-bold-p16 text-center">MOTIVER ET RÉCOMPENSER DURABLEMENT</span>
            <span v-if="!isPhone" class="link-text mt-4 raleway-medi-p16" :class="occasionSelection === 'option1' ? 'text-white' : ''" @click="">EN SAVOIR PLUS</span>
          </div>
        </div>
        <div class="col-12 col-md-4 occasion-selections" :class="[occasionSelection === 'option2' ? 'selected' : '', isPhone ? 'mt-3' : 'ml-3']" @click="occasionSelection = 'option2'">
          <div class="w-100 d-flex flex-column align-items-center justify-content-center h-100">
            <span class="raleway-bold-p16 text-center">ENRICHIR VOS CAMPAGNES MARKETING</span>
            <span v-if="!isPhone" class="link-text mt-4 raleway-medi-p16" :class="occasionSelection === 'option2' ? 'text-white' : ''" @click="">EN SAVOIR PLUS</span>
          </div>
        </div>
        <div class="col-12 col-md-4 occasion-selections" :class="[occasionSelection === 'option3' ? 'selected' : '', isPhone ? 'mt-3' : 'ml-3']" @click="occasionSelection = 'option3'">
          <div class="w-100 d-flex flex-column align-items-center justify-content-center h-100">
            <span class="raleway-bold-p16 text-center">VALORISER VOS ÉQUIPES AVEC COHÉRENCE</span>
            <span v-if="!isPhone" class="link-text mt-4 raleway-medi-p16" :class="occasionSelection === 'option3' ? 'text-white' : ''" @click="">EN SAVOIR PLUS</span>
          </div>
        </div>
      </div>
      <p v-if="occasionSelection == 'option1'" class="raleway-reg-p15 text-center py-4">Valorisez l’implication de vos collaborateurs tout en incarnant vos engagement RSE.</p>
      <p v-else-if="occasionSelection == 'option2'" class="raleway-reg-p15 text-center py-4">Attirez de nouveaux clients et renforcez votre image de marque grâce à un cadeau d’exception.</p>
      <p v-else-if="occasionSelection == 'option3'" class="raleway-reg-p15 text-center py-4">Célébrez les temps forts professionnels avec des cadeaux qui reflètent vos valeurs.</p>
      <div class="occasion-images">
        <div v-for="item in occasionImages" class="d-flex flex-column justify-content-center align-items-center occasion-image">
          <img :src="item.image" v-set-alt>
          <p class="raleway-semi-p16 w-100 text-center">{{ item.label }}</p>
        </div>
      </div>
    </div>
    <div v-if="selectedType === 'entreprise'" class="tool-details mt-5" :class="isPhone ? '' : 'row'"  data-aos="fade-up" data-aos-duration="900">
      <div class="w-100 d-flex flex-column justify-content-center align-items-center">
        <p class="merriweather-italic-24 text-center">Un outil simple et flexible pour vos actions RSE</p>
        <div class="tool-items mt-3 w-100">
          <div class="tool-item">
            <img src="../../images/euro_icon.png" v-set-alt style="width: 57px;height: 57px;">
            <p class="text-center mt-4" :class="isPhone? 'raleway-semi-p15' : 'raleway-semi-p16'">MONTANT DU COFFRET MODULABLE SELON VOTRE BUDGET</p>
          </div>
          <div class="tool-item">
            <img src="../../images/entreprise-footer-2.png" v-set-alt style="width: 68px;height: 67px;">
            <p class="text-center mt-3" :class="isPhone? 'raleway-semi-p15' : 'raleway-semi-p16'">VERSION DIGITALE OU IMPRIMÉE</p>
          </div>
          <div class="tool-item">
            <img src="../../images/entreprise-footer-3.png" v-set-alt style="width: 57px;height: 57px;">
            <p class="text-center mt-4" :class="isPhone? 'raleway-semi-p15' : 'raleway-semi-p16'">COFFRET PERSONNALISABLE À VOS COULEURS</p>
          </div>
          <div class="tool-item">
            <img src="../../images/entreprise-footer-4.png" v-set-alt style="width: 57px;height: 57px;">
            <p class="text-center mt-4" :class="isPhone? 'raleway-semi-p15' : 'raleway-semi-p16'">ACCOMPAGNEMENT DÉDIÉE POUR VOS PROJET SUR MESURE</p>
          </div>
        </div>
      </div>
    </div>
    <div v-if="selectedType === 'cse-collective'" class="tool-details-cse mt-5" :class="isPhone ? '' : 'row'"  data-aos="fade-up" data-aos-duration="900">
      <div class="w-100 d-flex flex-column justify-content-center align-items-center">
        <p class="merriweather-italic-24 text-center">Des solutions pensées pour les CSE</p>
        <div class="tool-items-cse mt-3 w-100">
          <div class="tool-item-cse h-100">
            <img src="../../images/cse-footer-1.png" v-set-alt style="width: 58px;height: 58px;">
            <div class="d-flex flex-column align-items-center h-100 content-item-cse">
              <p class="raleway-semi-p16 text-center mt-4 content-item-cse-title">CARTES CADEAUX PERSONNALISÉES</p>
              <p class="raleway-reg-p15 text-center">Offrez à vos collaborateurs la liberté de choisir leur escapade, en version physique ou digitale. Valable 2 ans.</p>
            </div>
          </div>
          <div class="tool-item-cse h-100">
            <img src="../../images/cse-footer-2.png" v-set-alt style="width: 57px;height: 57px;">
            <div class="d-flex flex-column align-items-center h-100 content-item-cse">
              <p class="raleway-semi-p16 text-center mt-4 content-item-cse-title">COMMANDES GROUPÉES & ÉVÉNEMENTS INTERNES</p>
              <p class="raleway-reg-p15 text-center">Une sélection d’offres pensées pour vos temps forts avec un stock dédié de cartes cadeaux activables à la demande.</p>
            </div>
          </div>
          <div class="tool-item-cse h-100">
            <img src="../../images/cse-footer-3.png" v-set-alt style="width: 71px;height: 58px;">
            <div class="d-flex flex-column align-items-center h-100  content-item-cse">
              <p class="raleway-semi-p16 text-center mt-4 content-item-cse-title">ACCOMPAGNEMENT CLÉ EN MAIN</p>
              <p class="raleway-reg-p15 text-center">Outils de communication et de vente fournis pour valoriser votre offre au sein du CSE.</p>
            </div>
          </div>
          <div class="tool-item-cse h-100">
            <img src="../../images/cse-footer-4.png" v-set-alt style="width: 58px;height: 58px;">
            <div class="d-flex flex-column align-items-center h-100 content-item-cse">
              <p class="raleway-semi-p16 text-center mt-4 content-item-cse-title">OFFRES REMISÉES EN LIGNE</p>
              <p class="raleway-reg-p15 text-center">Mise en place d’un code exclusif remisé, pour un accès 24h/24 à nos séjours d’exception à tarifs préférentiels.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <p class="mt-4 w-100 text-center" :class="isPhone ? 'merriweather-reg-20' : 'merriweather-reg-24'">Vous souhaitez en savoir plus ?</p>
    <div class="d-flex w-100 justify-content-center align-items-center mt-4" :class="isPhone ? 'px-5' : ''">
      <div class="hortense-btn-primary" @click="showContactModal = true">TÉLÉCHARGER NOTRE PLAQUETTE</div>
    </div>
    <div class="contact-container mt-5"  data-aos="fade-up" data-aos-duration="900" id="contactForm">
      <div class="border-bottom-gray"></div>
      <p class="raleway-reg-p15 mt-5 text-center">Si vous souhaitez être recontacté par notre équipe, il vous suffit de remplir le formulaire ci-dessous.</p>
      <div class="contact-form">
        <div class="row line-form mb-2">
          <label for="name" class="col-12">
            Nom *
            <input v-model="contact.last_name"  type="text" />
          </label>
        </div>
        <div class="row line-form mb-2">
          <label for="name" class="col-12">
            Prénom *
            <input v-model="contact.first_name"  type="text" />
          </label>
        </div>
        <div class="row line-form mb-2">
          <label for="name" class="col-12">
            Entreprise *
            <input v-model="contact.entreprise"  type="text" />
          </label>
        </div>
        <div class="row line-form mb-2">
          <label for="name" class="col-12">
            Poste
            <input v-model="contact.job"  type="text" />
          </label>
        </div>
        <div class="row line-form mb-2">
          <label for="name" class="col-12">
            Adresse e-mail professionnelle *
            <input v-model="contact.email"  type="text" />
          </label>
        </div>
         <div class="row line-form mb-2">
          <label for="name" class="col-12">
            Numéro de téléphone *
            <input v-model="contact.phone"  type="text" />
          </label>
        </div>
        <p class="raleway-reg-p15">* Champs obligatoires</p>
        <p v-if="formError" class="text-danger text-center raleway-reg-p13">Veuillez remplir tous les champs obligatoires.</p>
        <div class="d-flex w-100 justify-content-center align-items-center" :class="isPhone ? 'px-5' : ''">
          <div class="hortense-btn-primary" @click="submitContactForm()">NOUS CONTACTER</div>
        </div>
        <div v-if="success" class="text-success text-center mt-3">
          
        </div>
      </div>
    </div>
    <div class="bottom-banner mt-5" :class="selectedType === 'entreprise' ? 'bottom-banner-entreprise' : 'bottom-banner-cse-collective'">
      <div class="d-flex flex-column justify-content-center align-items-center">
        <p class="merriweather-reg-24">PARLONS DE VOTRE PROJET</p>
        <p class="raleway-reg-p15">Envie d’en savoir plus ou de recevoir une proposition sur-mesure ? Notre équipe dédiée entreprises est à votre écoute.</p>
        <p class="raleway-bold-p15 mt-3 mb-1">UN PROJET ? UNE QUESTION ?</p>
        <p class="raleway-reg-p15">Contactez notre équipe à <a class="raleway-bold-p15 link-email" href="mailto:servicecorporate@hortense.green">servicecorporate@hortense.green</a></p>
      </div>
    </div>
    <GiftBoxLimitedFaqs :selected-type="selectedType" />
  </div>
</template>
<script>
import ExceptionalEntrepriseExperience from "./ExceptionalEntrepriseExperience.vue";
import ExperienceCollections from './ExperienceCollections.vue';
import CoffretHortense from './CoffretHortense.vue';
import ModalContactForm from '../../components/modals/ModalContactForm.vue';
import GiftBoxLimitedFaqs from "./GiftBoxLimitedFaqs.vue";
import ModalContactFormSuccess from '../../components/modals/ModalContactFormSuccess.vue';

export default {
  name: "GiftBoxIndex",
  components: {
    ExceptionalEntrepriseExperience,
    ExperienceCollections,
    CoffretHortense,
    ModalContactForm,
    GiftBoxLimitedFaqs,
    ModalContactFormSuccess
  },
  data() {
    return {
      showMoreOfferContent: false,
      showContactModal: false,
      isPhone: window.innerWidth <= 768,
      selectedType: 'entreprise',
      occasionSelection: 'option1',
      formError: false,
      success: false,
      contact: {
        first_name: null,
        last_name: null,
        email: null,
        entreprise: null,
        job: null,
        phone: null,
      },
      showAllBullets: false,
      occasionImagesData: {
        'option1': [{
          image: 'https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Coffrets+cadeaux+-+BtoB/Programmes-incentives-responsables.webp',
          label: 'PROGRAMMES D’INCENTIVES RESPONSABLES'
        },
        {
          image: 'https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Coffrets+cadeaux+-+BtoB/Incentive-+animations-points-vente.webp',
          label: 'INCENTIVES & ANIMATIONS POINTS DE VENTES'
        },
        {
          image: 'https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Coffrets+cadeaux+-+BtoB/Challenges-commerciaux.webp',
          label: 'CHALLENGES COMMERCIAUX'
        }],
        'option2': [{
          image: 'https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Coffrets+cadeaux+-+BtoB/Dotations-pour-jeux-concours.webp',
          label: 'DOTATIONS POUR JEUX CONCOURS'
        },
        {
          image: 'https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Coffrets+cadeaux+-+BtoB/Fid%C3%A9lisation-de-clients-premium.webp',
          label: 'FIDÉLISATION DE CLIENTS PREMIUM'
        },
        {
          image: 'https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Coffrets+cadeaux+-+BtoB/Remerciements-post-%C3%A9v%C3%A9nements.webp',
          label: 'REMERCIEMENTS POST-ÉVÉNEMENTS'
        }],
        'option3': [{
          image: 'https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Coffrets+cadeaux+-+BtoB/Cadeaux-de-fin-ann%C3%A9e.webp',
          label: 'CADEAUX DE FIN D’ANNÉE'
        },
        {
          image: 'https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Coffrets+cadeaux+-+BtoB/Bienvenue-Onboarding.webp',
          label: 'BIENVENUE ( ONBOARDING)'
        },
        {
          image: 'https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Coffrets+cadeaux+-+BtoB/D%C3%A9parts-anniversaires.webp',
          label: 'DÉPARTS, ANNIVERSAIRES, NAISSANCES, MARIAGES'
        }]
      }
    };
  },
  mounted() {
    if (window.location.pathname === '/coffrets-cadeaux-cse') {
      this.selectedType = 'cse-collective';
    }
    const navbarItems = document.querySelectorAll('.bm-burger-bars');

    navbarItems.forEach((bar) => {
      bar.style.color = 'white';
      bar.style.backgroundColor = 'white';
      bar.style.border = '0.5px solid white';
    });
  },
  computed: {
    occasionImages() {
      return this.occasionImagesData[this.occasionSelection];
    }
  },
  methods: {
    validEmail(email) {
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return re.test(email);
    },
    validateForm() {
      const { first_name, last_name, entreprise, email, phone } = this.contact;
      return (
        first_name &&
        last_name &&
        entreprise &&
        phone &&
        email &&
        this.validEmail(email)
      );
    },
    async submitContactForm() {
      this.formError = false;

      if (!this.validateForm()) {
        this.formError = true;
        return;
      }

      try {
        const formData = new FormData();
        Object.entries(this.contact).forEach(([key, value]) => {
          formData.append(key, value);
        });

        await fetch("https://formspree.io/f/xrbkbplj", {
          method: "POST",
          body: formData,
          headers: { Accept: "application/json" }
        });

        this.success = true;
        this.contact = {
          first_name: '',
          last_name: '',
          entreprise: '',
          email: '',
          job: '',
          phone: '',
        };
      } catch (e) {
        alert("Une erreur s'est produite. Veuillez réessayer plus tard.");
      }
    },
    goToLink(link) {
      window.open(link, '_blank');
    },
    scrollToElement(elementId) {
      const element = document.getElementById(elementId);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'nearest',
        });
      }
    }
  }
};
</script>
<style scoped lang="scss">
.gift-box-index {
  width: 100%;

  .top-banner-entreprise {
    background-image: url('https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Coffrets+cadeaux+-+couverture/page-couverture-entreprise-desktop.webp');
    background-size: cover;

    @media screen and (max-width: 767px) {
      background-image: url('https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Coffrets+cadeaux+-+couverture/page-couverture-entreprise-mobile.webp');
      background-size: cover;
    }
  }

  .top-banner-cse-collective {
    background-image: url('https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Coffrets+cadeaux+-+couverture/page-couverture-CSE-desktop.webp');
    background-size: cover;

    @media screen and (max-width: 767px) {
      background-image: url('https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Coffrets+cadeaux+-+couverture/page-couverture-CSE-mobile.webp');
      background-size: cover;
    }
  }
  .top-banner {
    height: 399px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

    .top-banner-content {
      width: 100%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      color: white;
    }

    .image-gradient-bottom {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 115%;
      background: linear-gradient(to top, rgba(0, 0, 0, 0.6), transparent);
      pointer-events: none;
    }
  }
  .coffert-hortense-container {
    padding: 0 7% 0 7%;
  }

  .selection-btns-container {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 50px;

    @media screen and (max-width: 768px) {
      gap: 6px;
    }

    .selection-button {
      padding: 19px;
      border-radius: 19px;
      border: 2px solid #3B6152;
      color: #3B6152;
      width: 203px;
      height: 37px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-family: $Raleway;
      font-weight: 600;
      font-size: 15px;
      cursor: pointer;

      @media screen and (max-width: 768px) {
        width: fit-content;
      }
    }
    .selected {
      background-color: #3B6152;
      color: white;
    }
  }

  .offer-container {
    background: #F7F7F7 0% 0% no-repeat padding-box;
    min-height: 390px;
    padding: 36px 180px 36px 180px;

    @media screen and (max-width: 768px) {
      padding: 15px 50px 35px 50px;
    }
  }

  .entreprise-experience-container {
    padding: 0 1% 0 1%;
  }

  .choose-gift-box-container {

    .video-container {
      width: 100%;
      height: 444px;
      object-fit: cover;
    }
    .bullet {
      display: inline-block;
      width: 18px;
      height: 18px;
      background-color: white;
      background-image: url('../../images/circle_bullet.png');
      margin-right: 8px;
    }

    img {
      height: 444px;
      width: 100%;
      object-fit: cover;
    }
  }

  .occasions_container {
    padding: 0 7% 0 7%;

    .occasion-selections {
      border: 1px solid #3B6152;
      height: 170px;
      max-width: 304px;
      background-color: white;
      color: #3B6152;
      cursor: pointer;

      @media screen and (max-width: 768px) {
        width: 100%;
        height: 93px;
      }
    }

    .selected {
      background-color: #3B6152;
      color: white;
    }

    .occasion-images {
      display: flex;
      justify-content: center;
      align-items: start;
      gap: 12px;

      @media screen and (max-width: 768px) {
        justify-content: start;
        overflow-x: auto;
      }

      .occasion-image {
        width: 389px;

        img {
          width: 389px;
          height: 257px;
          object-fit: cover;

          @media screen and (max-width: 768px) {
            width: 226px;
            height: 257px;
          }
        }
        p {
          padding: 10px 15px 0 15px;
        }
      }
    }
  }

  .tool-details {
    width: 100%;
    min-height: 261px;
    background: #CFE5DC9D 0% 0% no-repeat padding-box;
    padding: 34px 67px 27px 84px;

    @media screen and (max-width: 768px) {
      padding: 28px 47px 49px 47px;
    }

    .tool-items {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 90px;

      @media screen and (min-width: 769px) and (max-width: 1400px) {
        gap: 30px;
      }

      @media screen and (max-width: 768px) {
        overflow-x: auto;
        flex-wrap: nowrap;
        justify-content: flex-start;
        align-items: flex-start;
        gap: 30px;
      }

      @media screen and (max-width: 768px) {
        gap: 30px;
      }

      .tool-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        @media screen and (max-width: 768px) { 
          width: 187px;
          flex: 0 0 auto;
          height: 150px;
          border-right: 0.5px solid #707070;
          padding-right: 1rem;

          &:last-child {
            border-right: none;
            padding-right: 0;
          }
        }
      }
    }
  }

  .tool-details-cse {
    width: 100%;
    min-height: 261px;
    background: #CFE5DC9D 0% 0% no-repeat padding-box;
    padding: 34px 67px 27px 84px;

    @media screen and (max-width: 1755px) {
      min-height: 355px;
    }

    @media screen and (min-width: 769) and (max-width: 1345px) {
      min-height: 460px;
    }

    @media screen and (max-width: 768px) {
      padding: 28px 10px 40px 10px;
    }

    .tool-items-cse {
      display: flex;
      justify-content: center;
      align-items: start;
      gap: 50px;

      @media screen and (max-width: 768px) {
        overflow-x: auto;
        flex-wrap: nowrap;
        justify-content: flex-start;
        align-items: flex-start;
        gap: 30px;
      }

      @media screen and (max-width: 768px) {
        gap: 30px;
      }

      .content-item-cse {
        .content-item-cse-title {
          @media screen and (max-width: 1755px) {
            min-height: 50px;
          }
        }
      }

      .tool-item-cse {
        display: flex;
        flex-direction: column;
        align-items: center;
        @media screen and (max-width: 768px) { 
          width: 300px;
          flex: 0 0 auto;
          overflow-y: hidden;
          height: 240px;
          border-right: 0.5px solid #707070;
          padding-right: 1rem;

          &:last-child {
            border-right: none;
            padding-right: 0;
          }
        }
      }
    }
  }

  .contact-container {
    padding: 0 20% 0 20%;
    @media screen and (max-width: 768px) {
      padding: 0 3% 0 3%;
    }

    .contact-form {
      background: #FFFFFF 0% 0% no-repeat padding-box;
      box-shadow: 3px 3px 6px #D6CFCF;
      padding: 50px;
      @media screen and (max-width: 768px) {
        padding: 26px 32px 20px 20px;
      }

      .line-form {
        label {
          display: flex;
          flex-direction: column;
          font-family: $Raleway;
          font-weight: 600;
          font-size: 15px;
          color: #000000;
          line-height: 18px;
        }
        input[type="text"] {
          padding: 14px;
          gap: 10px;
          height: 42px;
          border: 1px solid #3B6152;
          margin-top: 8px;

          @media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
            width: 100%;
          }

          &:focus {
            outline: none;
          }
        }
      }
    }
  }

  .bottom-banner-entreprise {
    background-image: url('https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Coffrets+cadeaux+-+BtoB/Encart+contact+-+BtoB+-+entreprises.webp');
    background-size: cover;
  }

  .bottom-banner-cse-collective {
    background-image: url('https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Coffrets+cadeaux+-+BtoB/Encart+contact+-+BtoB+-+CSE.webp');
    background-size: cover;
  }

  .bottom-banner {
    min-height: 247px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;

    @media screen and (max-width: 768px) {
      padding: 26px 50px 26px 50px;
      text-align: center;
    }
  }

  .award-container {
    padding: 0 12% 0 12%;

    @media screen and (max-width: 768px) {
      padding: 0 3% 0 3%;
    }
    img {
      width: 100%;
      height: 267px;
      object-fit: cover;

      @media screen and (max-width: 768px) {
        width: 358px;
        height: 267px;
      }
    }

    .row-grid {
      display: grid;
      grid-template-columns: repeat(2, 1fr);;
      gap: 20px;

      @media screen and (max-width: 768px) {
        display: flex;
        justify-content: start;
        overflow-x: auto;
      }
    }
  }

  .border-bottom-gray {
    border-bottom: 0.5px solid #707070;
  }
  
  .link-text {
    text-decoration: underline;
    color: #3B6152;
    cursor: pointer;
  }

  .link-email {
    color: white;
    cursor: pointer;
    transition: color 0.2s ease-in-out;

    &:hover {
      color: white;
      font-weight: bold;
    }
  }
}
</style>